let getPublicationsByTwoConditions = async ({
  url,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
          itemsDosCondiciones(
            hasMetadata: {
              AND: [
                {column:METADATA_FIELD_ID,operator:EQ,value:57}
                {column:VALUE,operator:EQ,value:"LAMAR"}
              ]     
          }
            hasMetadata1: {
            AND: [
              {column:METADATA_FIELD_ID,operator:EQ,value:7}
              {column:VALUE,operator:EQ,value:"Huancayo"}
            ]
            
          }
            orderBy: [
              { column: ISSUED_DATE, order: DESC },
              { column: HANDLE, order: DESC }
            ]
            , first: ${itemsPerPage}, page: ${currentPage}) {
            paginatorInfo{
                count
                total 
                currentPage
                hasMorePages
              }
              data{
                id
                handle
                thumbnail
                metadata{
                  metadata_field_id
                  value
                }
                
              }
          }
        }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.itemsDosCondiciones);
};

export { getPublicationsByTwoConditions };
